import { Grid, Paper, Typography } from '@mui/material';
import React from 'react';

import { RouterLink } from 'app/components/router-link';
import { Store } from 'app/model/cris/store';
import { Formatters } from 'app/utils/formatters';

interface StoreDetailViewProps {
    store: Store;
}

export const StoreDetailView: React.FunctionComponent<StoreDetailViewProps> = ({ store }) => {
    const brand = store.brand;

    return (
        <Paper elevation={3} className='p-2'>
            <Typography variant='h5'>Store Details</Typography>
            <Grid container>
                <Grid item xs={4}>
                    <Typography>
                        <strong>Name</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.name}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Store Num</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.storeNum}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Phone</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.phone}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Owner Id</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.storeownerId}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>MID Given</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.midGiven}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Is Default</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.isDefault ? 'Yes' : 'No'}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Brand</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <RouterLink to={`/cris/brands/${brand?.id || 0}/details`}>{brand?.name}</RouterLink>
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Type</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.type}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Domain</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.domain}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Location Id</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.locationId}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Date Opened</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {Formatters.date(store.dateOpened)}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Date Closed</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {Formatters.date(store.dateClosed)}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Source</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.source}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Default Channel</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.defaultChannel}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Old Stores</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {store.oldStores?.join(', ')}
                </Grid>

                <Grid item xs={12}>
                    <Typography variant='h5'>Spend Info</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Spend</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    ${Number(store.spendInfo?.spend).toLocaleString()}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Trx Count</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {Number(store.spendInfo?.trxCount).toLocaleString()}
                </Grid>
            </Grid>
        </Paper>
    );
};
